// src/utils/logout.ts

export const logout = async () => {
  try {
    await fetch(`${import.meta.env.VITE_API_URL || ''}/admin/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch {
    // ignore
  }
  localStorage.removeItem('admin_user');
  location.href = '/auth/login';
};
